<template>
  <q-btn
    :aria-label="$t('accessibility.aria.removeSeat')"
    :data-test="CypressTarget('Remove')"
    v-bind="quasarButtonProps"
    @click="$emit('click')"
  />
</template>
<script>
  import QuasarButtonProps from 'mixins/components/button/common/quasarButtonProps';

  export default {
    name: 'ButtonRemove',
    mixins: [QuasarButtonProps],
    props: {
      flat: {
        type: Boolean,
        required: false,
        default: true,
      },
      icon: {
        type: String,
        required: false,
        default: 'delete',
      },
      color: {
        type: String,
        required: false,
        default: 'red',
      },
    },
  };
</script>
